module.exports = __webpack_public_path__ + "img/bedtime.8424e294.svg";